import React, { Component } from 'react';
import classNames from 'classnames';
require('./pageNav.scss');
export default class IndexTabSwitch extends Component {
    constructor(props,context) {
        super(props,context);
        this.onTouchTap = this.onTouchTap.bind(this);
        let navData = this.initData(props);
        this.state = {
            navData
        };
    }
    componentWillReceiveProps(nextProps) {
        let navData = this.initData(nextProps);
        this.setState(navData,() => {
            this.changeBottomStyle(this.getTransStyle());
        });
    }
    componentDidMount() {
        this.changeBottomStyle(this.getTransStyle());
        const tabActive = document.getElementsByClassName('active')[0];
        tabActive.scrollIntoView(true);
    }
    shouldComponentUpdate(nextProps ,nextState) {
        return this.state.currentViewName != nextState.currentViewName ||
               nextState.title != this.state.title ||
               nextProps.tabstyle != this.props.tabstyle;
    }
    onTouchTap(view,e) {
        e.preventDefault();
        const { currentViewName } = this.state;
        // 增加拦截
        if(currentViewName === view.name) {
            return;
        }
        this.setState({
            title: view.label,
            currentViewName: view.name
        },function() {
            this.changeBottomStyle(this.getTransStyle());
            if(this.props.viewActived) {
                this.props.viewActived(view);
            }
        }.bind(this));
    }
    getTransStyle() {
        const tabActive = document.getElementsByClassName('active')[0];
        const width = tabActive.offsetWidth + 16;
        const translateX = tabActive.offsetLeft - 32;
        return { width, translateX };
    }
    changeBottomStyle(style) {
        const bottomLine = this.refs.tabBottomLine;
        const { width, translateX } = style;
        if(bottomLine) {
            bottomLine.style.width = width + 'px';
            bottomLine.style.transform = `translateX(${translateX}px)`;
            bottomLine.style.WebkitTransform = `translateX(${translateX}px)`;
        }
    }
    initData(props) {
        const { biz_data, sub_cmps, cmp_data } = props;
        if(biz_data && sub_cmps && cmp_data) {
            let NavData = {
                title: biz_data ? biz_data[cmp_data.currentViewName] && biz_data[cmp_data.currentViewName].text : ''
                ,currentViewName: cmp_data ? cmp_data.currentViewName : ''
                ,data: []
            };
            sub_cmps.forEach(item => {
                if(item.cmp_data && item.cmp_data.name && biz_data[item.cmp_data.name]) {
                    const Item = {
                        name: item.cmp_data.name ,
                        metaObjName: item.cmp_data.metaObjName,
                        label: biz_data[item.cmp_data.name] && biz_data[item.cmp_data.name].text || '',
                        value: item.cmp_name,
                        cmp_data: item.cmp_data
                        };
                    NavData.data.push(Item);
                }
            });
            return NavData;
        }
        return {};
    }
    render() {
        const currentViewName = this.state.currentViewName || this.state.navData.currentViewName;
        const tabItem = this.state.navData.data.map(item => {
            return (
                <div key={item.name}
                      className={classNames('index_tab_item', { 'active': item.name == currentViewName })}
                      onTouchTap={this.onTouchTap.bind(this, item)}
                >
                    {item.label}
                </div>
            );
        });
        return (
            <div className={classNames('index_tab_container border-1px',{ 'hidden': this.state.navData.data.length <= 1 })} ref='indextab'>
                <div className='tabitem_bottom' ref="tabBottomLine" />
                {tabItem}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/PageNav/IndexTabSwitch.js